import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../../utils/story";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";
import SubHeadline from "../../../atoms/SubHeadline";

import "../three-column-five-stories-var-one.m.css";

const StoryCard = ({ story, showTimeStamp, showReadTime, showSubHeadline, bigIcon, sectionSlug }) => {
  let iconSizes = bigIcon ? { height: 32, width: 32 } : { height: 24, width: 24 };
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target}>
      <div styleName="card">
        <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={iconSizes} />
        {label && <Label story={story} />}

        {headline && <Headline styleName="heading" headline={headline} sectionSlug={sectionSlug} />}
        {showSubHeadline && story?.subheadline && (
          <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
        )}
        <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
      </div>
    </Link>
  );
};

StoryCard.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string,
    subheadline: PropTypes.string,
  }),
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  showSubHeadline: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default StoryCard;
